function isEmptyArray(array) {
  if (array === void 0) {
    return true;
  }
  if (array.length === 0) {
    return true;
  }
  return false;
}

export { isEmptyArray as default };
//# sourceMappingURL=isEmptyArray.mjs.map
